<template>
  <v-app>

      <Auth v-if="!$store.state.auth"></Auth>
      <Main v-else></Main>
 
  </v-app>
</template>

<script>
import Auth from "./components/Auth.vue";
import Main from "./components/Main.vue";

export default {
  name: "App",

  components: {
    Auth,
    Main,
  },

  data: () => ({

  }),
  async created() {
    this.$store.commit("setHeight", window.innerHeight);
    if (window.innerWidth < 1201) this.$store.commit("setMobileStatus", true);
    else this.$store.commit("setDesctopStatus", true);
  },
 
};
</script>
